module.exports = require("./es-419.d.ts");